import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-flight-block-skeleton',
  templateUrl: './flight-block-skeleton.component.html',
  styleUrls: ['./flight-block-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlightBlockSkeletonComponent {}
